<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round">
  <rect x="4.5" y="4.5" width="6" height="6" rx="1.2" />
  <rect x="13.5" y="4.5" width="6" height="6" rx="1.2" />
  <rect x="13.5" y="13.5" width="6" height="6" rx="1.2" />
  <rect x="4.5" y="13.5" width="6" height="6" rx="1.2" />
</svg>